import { createApi } from "@reduxjs/toolkit/query/react";
import { customBaseQuery } from "@store/baseQuery";

export const promptApi = createApi({
  reducerPath: "promptsApi",
  baseQuery: customBaseQuery,
  tagTypes: ["PromptConfig"],
  endpoints: (builder) => ({
    getAgentParemeters: builder.mutation({
      query: (data) => ({
        url: "demo_chat/agent_parameters",
        method: "POST",
        body: data,
      }),
    }),
    updateAgentParemeters: builder.mutation({
      query: (data) => ({
        url: "demo_chat/agent_parameters",
        method: "PATCH",
        body: data,
      }),
    }),
    resetAgentParemeters: builder.mutation({
      query: (data) => ({
        url: "demo_chat/agent_parameters",
        method: "PUT",
        body: data,
      }),
    }),
    getPromptConfiguration: builder.query<any, void>({
      query: () => ({
        url: "configuration/prompts/",
        method: "GET",
      }),
      providesTags: ["PromptConfig"],
    }),
    updatePromptConfiguration: builder.mutation<any, { payload: any }>({
      query: ({ payload }) => ({
        url: `configuration/prompts/`,
        method: "PATCH",
        body: payload,
      }),
      invalidatesTags: ["PromptConfig"],
    }),
  }),
});

export const {
  useGetAgentParemetersMutation,
  useUpdateAgentParemetersMutation,
  useResetAgentParemetersMutation,
  useGetPromptConfigurationQuery,
  useUpdatePromptConfigurationMutation,
} = promptApi;